import {
    WarningType,
    ErrorFunction,
    PipelineInfoData,
} from "@vonage/media-processor";
import {
    BlurRadius,
    BackgroundBlurConfig,
    VirtualBackgroundConfig,
    AssetBackgroundConfig,
    VideoBackgroundConfig,
    MediaProcessorBaseConfig,
    SilhouetteBlurConfig,
    SupportedBrowserFeatures,
    FeatureSupport,
    WebglSelfieSegmentationType,
    BackgroundOptions,
    BackgroundTransformerType,
    RenderingOptions,
    RenderingType,
    SegmentationOptions,
} from "./src/types";
import { isSupported, getSupportedBrowserFeatures } from "./src/utils/support";
import { VonageMediaProcessor } from "./src/facades/vonage-media-processor";
import { BackgroundTransformer } from "./src/transformers/background-transformer";

/**
 * MediaProcessorConfig specifies the transformer logic to be performed.
 */
type MediaProcessorConfig = BackgroundOptions;

/**
 * builder function to create MediaProcessor
 * @param config - see `MediaProcessorConfig` definition
 * @returns - `MediaProcessor` provide interface to configure ml-transformer or retrieving connector
 */
export async function createVonageMediaProcessor(
    config: MediaProcessorConfig
): Promise<VonageMediaProcessor> {
    return await VonageMediaProcessor.create(config);
}

export type {
    EventDataMap,
    WarnData,
    ErrorData,
    EventMetaData,
    DropInfo,
} from "@vonage/media-processor";

export type {
    MediaProcessorBaseConfig,
    BackgroundBlurConfig,
    VirtualBackgroundConfig,
    VideoBackgroundConfig,
    AssetBackgroundConfig,
    SilhouetteBlurConfig,
    MediaProcessorConfig,
    BackgroundOptions,
    SupportedBrowserFeatures,
    FeatureSupport,
    RenderingOptions,
    SegmentationOptions,
};

export {
    VonageMediaProcessor,
    BlurRadius,
    isSupported,
    getSupportedBrowserFeatures,
    WarningType,
    PipelineInfoData,
    ErrorFunction,
    BackgroundTransformer,
    WebglSelfieSegmentationType,
    BackgroundTransformerType,
    RenderingType,
};
